import type {SheetOffset} from "../utils/types";
import {MinusIcon, PlusIcon, ResetIcon} from "./icons";
import styles from "./MapControls.module.css";

type MapControlsProps = {
    sheetOffset: SheetOffset;
    isPortrait: boolean;
    showResetButton: boolean;
    onResetPosition: () => void;
    onZoomIn: () => void;
    onZoomOut: () => void;
};

export function MapControls({
    sheetOffset,
    isPortrait,
    showResetButton,
    onResetPosition,
    onZoomIn,
    onZoomOut,
}: MapControlsProps) {
    const wrapperStyle = {
        bottom: `${isPortrait ? sheetOffset.height + 16 : 16}px`,
    };

    return (
        <div className={styles.wrapper} style={wrapperStyle}>
            {showResetButton && (
                <button className={styles.floatButton} onClick={onResetPosition}>
                    <ResetIcon fill="#072948" />
                </button>
            )}
            {!isPortrait && (
                <div className={styles.segmentedButtons}>
                    <button onClick={onZoomIn}>
                        <PlusIcon fill="#072948" />
                    </button>
                    <button onClick={onZoomOut}>
                        <MinusIcon fill="#072948" />
                    </button>
                </div>
            )}
        </div>
    );
}
